import { render, staticRenderFns } from "./coupon-dialog.vue?vue&type=template&id=99a4bc2e&scoped=true&"
import script from "./coupon-dialog.vue?vue&type=script&lang=js&"
export * from "./coupon-dialog.vue?vue&type=script&lang=js&"
import style0 from "./coupon-dialog.vue?vue&type=style&index=0&id=99a4bc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a4bc2e",
  null
  
)

export default component.exports